import 'whatwg-fetch';

/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */
function parseJSON(response) {
  return response.json();
}

/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  var error = new Error(response.statusText);
  error.response = response;
  throw error;
}

/**
 * Requests a MENU_ITEMS_URL, returning a promise
 *
 * @param  {string} url       The MENU_ITEMS_URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */
export default function request(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/json'
    }),
    credentials: 'include'
  };
  var skipJson = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  checkHostname(url);
  if (skipJson) {
    return fetch(url, options).then(checkStatus);
  }
  return fetch(url, options).then(checkStatus).then(parseJSON);
}

function checkHostname(apiBaseUrl) {
  if (apiBaseUrl === undefined || apiBaseUrl === null || apiBaseUrl.length === 0) {
    throw new Error('The API hostname is not defined');
  }
}